import { render, staticRenderFns } from "./RevisionRecordTable.vue?vue&type=template&id=4a62e528&scoped=true"
import script from "./RevisionRecordTable.vue?vue&type=script&lang=ts"
export * from "./RevisionRecordTable.vue?vue&type=script&lang=ts"
import style0 from "./RevisionRecordTable.vue?vue&type=style&index=0&id=4a62e528&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a62e528",
  null
  
)

export default component.exports